<template>
  <div class="page">
    <div class="panel">
      <h1 class="title">首次进入 HEX 标志清理</h1>
      <p class="message">{{ message }}</p>
      <div
        v-if="stage === 'confirm'"
        class="actions"
      >
        <button
          class="confirm_btn"
          type="button"
          @click="clearAfterConfirm"
        >
          确认清除
        </button>
        <button
          class="cancel_btn"
          type="button"
          @click="handleCancel"
        >
          取消
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue"
import { useRoute, useRouter } from "vue-router"

const route = useRoute()
const router = useRouter()
const stage = ref("confirm")
const message = ref("")
const targetTaskId = ref("")

const clearSingleFlag = (taskId) => {
  const key = `${taskId}_fv`
  if (localStorage.getItem(key) === null) {
    return 0
  }

  localStorage.removeItem(key)
  return 1
}

const clearAllFlags = () => {
  const keys = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key && key.endsWith("_fv")) {
      keys.push(key)
    }
  }

  keys.forEach((key) => localStorage.removeItem(key))
  return keys.length
}

const closePage = () => {
  window.close()

  // 部分浏览器禁止直接关闭非脚本打开的页面，提供回退兜底
  setTimeout(() => {
    if (!document.hidden) {
      if (window.history.length > 1) {
        window.history.back()
      } else {
        router.replace({ name: "CourseList" })
      }
    }
  }, 200)
}

const clearAfterConfirm = () => {
  if (stage.value !== "confirm") {
    return
  }

  stage.value = "done"

  if (targetTaskId.value) {
    const cleared = clearSingleFlag(targetTaskId.value)
    message.value =
      cleared > 0
        ? `清除完成：任务 ${targetTaskId.value} 的首次进入 HEX 标志已清除。`
        : `清除完成：任务 ${targetTaskId.value} 未发现可清除标志。`
  } else {
    const count = clearAllFlags()
    message.value =
      count > 0
        ? `清除完成：已清除 ${count} 个首次进入 HEX 标志。`
        : "清除完成：未发现需要清除的首次进入 HEX 标志。"
  }

  message.value += " 页面即将自动关闭..."
  setTimeout(closePage, 900)
}

const handleCancel = () => {
  stage.value = "cancel"
  message.value = "已取消清除，页面即将关闭..."
  setTimeout(closePage, 500)
}

onMounted(() => {
  const taskIdParam = route.query.taskId
  const taskId = Array.isArray(taskIdParam) ? taskIdParam[0] : taskIdParam

  if (typeof taskId === "string" && taskId.trim()) {
    message.value = `将清除任务 ${taskId} 的首次进入 HEX 标志，是否继续？`
    targetTaskId.value = taskId
    return
  }

  message.value = "将清除本地全部首次进入 HEX 标志，是否继续？"
})
</script>

<style scoped>
.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f6f9ff 0%, #ecf2ff 100%);
  padding: 24px;
  box-sizing: border-box;
}

.panel {
  width: 100%;
  max-width: 560px;
  background: #ffffff;
  border: 1px solid #dbe8ff;
  border-radius: 16px;
  box-shadow: 0 12px 36px rgba(52, 94, 174, 0.14);
  padding: 28px 24px;
  text-align: center;
}

.title {
  margin: 0;
  color: #1e3a72;
  font-size: 24px;
  line-height: 1.35;
  font-weight: 700;
}

.message {
  margin: 16px 0 24px;
  color: #364b74;
  font-size: 16px;
  line-height: 1.6;
  word-break: break-word;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.confirm_btn {
  min-width: 132px;
  height: 42px;
  border: none;
  border-radius: 10px;
  background: #3f78e0;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.confirm_btn:hover {
  background: #2f68cf;
}

.cancel_btn {
  min-width: 132px;
  height: 42px;
  border: 1px solid #b7c9ef;
  border-radius: 10px;
  background: #ffffff;
  color: #3b4f73;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.cancel_btn:hover {
  background: #f3f7ff;
}
</style>
